import { z } from "zod";
import { ReportParameterExecuteDtoSchema } from "./ReportParameterExecuteDto";
import { ApprovedStateTypeEnumSchema } from "@/Enums/ApprovedStateType";

export const ReportExecuteDtoSchema = z.object({
    id: z.number(),
    name: z.string().nullable(),
    description: z.string(),
    icon: z.string().nullable(),
    iconColor: z.string().nullable(),
    expiresInDays: z.number().nullable(),
    approvedState: ApprovedStateTypeEnumSchema.nullable(),
    nameToShow: z.string().nullable(),
    isPeriodicReport: z.boolean(),
    parameters: z.array(ReportParameterExecuteDtoSchema),
});

export type ReportExecuteDto = z.infer<typeof ReportExecuteDtoSchema>;